import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import Flex from '../../../atoms/Flex';
import { MINIATURE } from '../../../constants';

const ProductCardAllGeoLocTags = ({
  allGeoLocTags,
  displayMode
}) => {
  return allGeoLocTags.length > 0 && /*#__PURE__*/React.createElement(Flex, {
    display: "none",
    "data-testid": "allGeoLocTags",
    flexDirection: "column"
  }, allGeoLocTags.map((geoLocTag, index) => {
    return geoLocTag.title && /*#__PURE__*/React.createElement(Flex, {
      key: index,
      alignItems: "center",
      display: displayMode === MINIATURE ? 'none' : null,
      color: "text.primary",
      fontSize: "0",
      fontWeight: "medium"
    }, geoLocTag.title);
  }));
};

process.env.NODE_ENV !== "production" ? ProductCardAllGeoLocTags.propTypes = {
  allGeoLocTags: arrayOf(shape({
    title: string
  })),
  displayMode: string
} : void 0;
ProductCardAllGeoLocTags.defaultProps = {
  allGeoLocTags: []
};
export default ProductCardAllGeoLocTags;